<template>
  <base-layout :title="title" :backLink="backLink" :reloadable="reloadable">
    <ion-refresher slot="fixed" @ionRefresh="refresh($event)">
      <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    <ion-grid fixed>
      <ion-row>
        <ion-col size="12">
          <list-stream :resources="resources"></list-stream>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-infinite-scroll threshold="100px" @ionInfinite="loadData($event)">
      <ion-infinite-scroll-content
        loading-spinner="bubbles"
        loading-text="Loading more data..."
      >
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>
    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
      <ion-fab-button @click="setCreateModalState(true)">
        <ion-icon :ios="addOutline" :md="addOutline"></ion-icon>
      </ion-fab-button>
    </ion-fab>
    <ion-modal :is-open="createModalState" @didDismiss="setCreateModalState(false)">
      <base-modal
        title="Create Stream"
        @closeModal="setCreateModalState(false)"
      >
        <create-stream @closeModal="setCreateModalState(false)"></create-stream>
      </base-modal>
    </ion-modal>
  </base-layout>
</template>

<script>
import BaseLayout from "../../Base/BaseLayout";
import BaseModal from "../../Base/BaseModal";
import CreateStream from "../../Components/Academic/Stream/CreateStream.vue";
import ListStream from "../../Components/Academic/Stream/ListStream.vue";

import {
  IonGrid,
  IonRow,
  IonCol,
  IonFab,
  IonIcon,
  IonFabButton,
  IonModal,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonRefresher,
  IonRefresherContent,
} from "@ionic/vue";

import { addOutline } from "ionicons/icons";

export default {
  components: {
    BaseLayout,
    BaseModal,
    CreateStream,
    ListStream,
    IonGrid,
    IonRow,
    IonCol,
    IonFab,
    IonIcon,
    IonFabButton,
    IonModal,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonRefresher,
    IonRefresherContent,
  },

  data() {
    return {
      title: "Academic Streams",
      backLink: "academic",
      reloadable: true,

      createModalState: false,

      addOutline,
    };
  },

  computed: {
    resources() {
      return this.$store.getters["stream/resources"];
    },
    shouldReload() {
      return this.$store.getters["reload"] === this.$route.name;
    },
  },

  watch: {
    shouldReload(current) {
      if (current) {
        this.refresh();
        this.$store.dispatch("clearReload");
      }
    },
  },

  methods: {
    async fetch(refresh = false) {
      await this.$store.dispatch("stream/resources", { refresh: refresh });
    },
    loadData(event) {
      this.fetch();
      event.target.complete();
    },
    async refresh(event) {
      await this.$store.dispatch("stream/resources", { refresh: true });
      if (event) {
        event.target.complete();
      }
    },
    setCreateModalState(state) {
      this.createModalState = state;
    },
  },

  created() {
    this.fetch();
  },
};
</script>

<style scoped>
</style>
